<script>
import {
  reservationComputed,
  reservationMethods,
} from '@state/reservationHelpers.js'
import Loading from '@views/_loading.vue'
export default {
  page: {
    title: 'Email resend',
    meta: [{ name: 'description', content: 'Email resend' }],
  },
  components: { Loading },
  data() {
    return {
      id: '',
      email: '',
    }
  },
  computed: {
    ...reservationComputed,
    computedListBooking() {
      return this.getListBooking
    },
    computedSendEmail() {
      return this.sendMailBookingSuccess
    },
    computedLoading() {
      return this.getIsLoading
    },
  },
  watch: {
    computedSendEmail() {
      if (this.computedSendEmail) {
        const company = this.$route.params.companyId
        const id = this.$route.params.id
        this.$router.push({ path: `/${company}/email-resend/${id}` })
      }
    },
    computedListBooking() {
      this.email =
        this.getListBooking &&
        this.getListBooking[0] &&
        this.getListBooking[0]?.email
    },
  },
  created() {
    const id = this.$route.params.id
    this.getListBookingDetail({ id: id })
  },
  methods: {
    ...reservationMethods,
    cancelResendEmail() {
      const company = this.$route.params.companyId
      this.$router.push({ path: `/${company}/reservation/` })
    },
    confirmResendEmail() {
      const id = this.$route.params.id
      this.setCurrentPage({ page: 1 })
      this.sendMailListBooking({ booking_id: id })
    },
  },
}
</script>

<template>
  <div id="idoors-email-resend">
    <BaseSubHeader />
    <div class="pt-8 pb-6 pl-6 pr-6 text-email-send">
      <p>{{ $t('textResendEmailPageReservation') }}</p>
      <p class="blue--text">{{ email }}</p>
      <div class="pt-7">
        <v-btn
          color="#5198d7"
          class="white--text custom_width custom_height mr-5"
          type="button"
          @click="confirmResendEmail"
          >OK</v-btn
        >
        <v-btn
          color="grey"
          class="white--text custom_height"
          type="button"
          @click="cancelResendEmail"
          >{{ $t('cancel') }}</v-btn
        >
      </div>
    </div>
    <Loading :loading="computedLoading" />
  </div>
</template>

<style lang="scss" scoped>
// @import '~vuetify/src/styles/styles.sass'
#idoors-email-resend {
  .custom_width {
    width: 100px !important;
  }
  .custom_height {
    height: 32px !important;
  }
}
</style>
